import { render, staticRenderFns } from "./ListIngredients.vue?vue&type=template&id=1187beb2&"
import script from "./ListIngredients.vue?vue&type=script&lang=js&"
export * from "./ListIngredients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports